/**
 * Множина за српски: документ/документа/докумената и обавеза/обавезе.
 * Користи се за section-title-meta и сличне приказе броја.
 */

/** 1 документ, 2–4 документа, 0/5+ докумената (укључујући 21 документ, 22–24 документа, итд.) */
export function pluralDocuments(n) {
  const num = Number(n);
  if (Number.isNaN(num)) return 'докумената';
  const mod10 = num % 10;
  const mod100 = num % 100;
  if (mod10 === 1 && mod100 !== 11) return 'документ';
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return 'документа';
  return 'докумената';
}

/** 0/1/5+ обавеза, 2–4 обавезе (укључујући 22–24 обавезе, итд.) */
export function pluralObligations(n) {
  const num = Number(n);
  if (Number.isNaN(num)) return 'обавеза';
  const mod10 = num % 10;
  const mod100 = num % 100;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return 'обавезе';
  return 'обавеза';
}

/** 1 обавештење, 2+ обавештења */
export function pluralNotifications(n) {
  const num = Number(n);
  if (Number.isNaN(num)) return 'обавештења';
  const mod10 = num % 10;
  const mod100 = num % 100;
  if (mod10 === 1 && mod100 !== 11) return 'обавештење';
  return 'обавештења';
}

/** 1 непрочитано, 2–4 непрочитана, 0/5+ непрочитаних */
export function pluralUnread(n) {
  const num = Number(n);
  if (Number.isNaN(num)) return 'непрочитаних';
  const mod10 = num % 10;
  const mod100 = num % 100;
  if (mod10 === 1 && mod100 !== 11) return 'непрочитано';
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return 'непрочитана';
  return 'непрочитаних';
}

/** нпр. „2 непрочитана“, „5 непрочитаних“ */
export function formatUnreadCount(n) {
  const num = Number(n);
  if (Number.isNaN(num) || num <= 0) return '';
  return `${num} ${pluralUnread(num)}`;
}
